var _style, _g, _g2, _g3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E8BF62;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_15"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    transform: "matrix(0.9641 -0.2656 0.2656 0.9641 -58.7992 77.1891)",
    width: 343.6,
    height: 343.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_14"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 84.2,
    y: 84.2,
    transform: "matrix(0.4939 -0.8695 0.8695 0.4939 -93.0369 352.1554)",
    width: 343.6,
    height: 343.6
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M223.7,286.3c12.1,3.5,23.9,4.9,34,2.1c10.5-2.9,16.1-9.8,13.8-18.3c-2.2-8-9.6-11.5-22.9-7.8l-11.1,3.1 l-5.1-18.5l10.5-2.9c12.1-3.3,16.2-10.5,14.1-18.3c-2.3-8.5-10.3-11.6-20.4-8.8c-7.7,2.1-15.7,7.5-21.2,12.8l-6-21.9 c5.5-5.8,13.9-10.5,23.2-13c22.7-6.3,43.1,2.4,48,20.2c3,11-0.7,22.1-9.8,28.8l0.1,0.3c13.7,0.9,22.8,9.7,26,21.3 c5.4,19.8-8.9,38.2-31.6,44.5c-12.1,3.3-25.5,3.4-34.7,0.2L223.7,286.3z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar3);
export default __webpack_public_path__ + "static/media/star_3.c47d4a1d9b7a22f071e7ab77945cd839.svg";
export { ForwardRef as ReactComponent };